import * as Primitive from "@radix-ui/react-switch";
import type { ComponentProps } from "react";

import { cn } from "../../lib/utils";

export function Switch({
  checked,
  onCheckedChange,
  className,
  id,
  disabled,
  "aria-label": ariaLabel,
  ...props
}: ComponentProps<typeof Primitive.Root> & {
  checked: boolean;
  onCheckedChange(next: boolean): void;
}) {
  return (
    <Primitive.Root
      {...props}
      aria-checked={checked}
      aria-label={ariaLabel}
      className={cn(
        "relative inline-flex h-5 w-9 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent bg-input transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/30 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary",
        className,
      )}
      disabled={disabled}
      id={id}
      checked={checked}
      onCheckedChange={onCheckedChange}
      data-slot="switch"
    >
      <Primitive.Thumb
        aria-hidden="true"
        className={cn(
          "pointer-events-none inline-block size-4 rounded-full bg-background shadow-sm transition-transform data-[state=checked]:translate-x-4 data-[state=unchecked]:translate-x-0",
        )}
      />
    </Primitive.Root>
  );
}
